export default "__VITE_ASSET__fG3EVjRE__"